export default __webpack_public_path__ + "static/media/1668.a0a0f755.png";